import React, { useContext } from 'react';

import { media } from 'context';
import { Icon, Layout, Link, StatusPill, Text } from 'ds';
import { CUSTOMER_SUPPORT_PATH } from 'routes';
import { selectCustomerSupportTicketsByTicketId } from 'store/AIAssistant/selectors';
import { useAppSelector } from 'store/hooks';
import { SupportTicket } from 'ux/Customer/Support/types';

import { getSupportTicketStatusPillProps } from 'ux/Admin/Support/supportTicketStatusConfig';

interface Props {
  action: string;
  supportTicket: SupportTicket;
}

const AIAssistantViewSupportTicket: React.FC<Props> = ({ action, supportTicket: { id } }) => {
  const { isMobile } = useContext(media);
  const supportTicket = useAppSelector(selectCustomerSupportTicketsByTicketId(id));
  if (!supportTicket) return null;
  const { title, description, status } = supportTicket;
  return (
    <Link href={`${CUSTOMER_SUPPORT_PATH}/${id}`} target="_blank" color="gray-900">
      <Layout color="gray-25" borderRadius={16} width={320}>
        {!isMobile && (
          <Layout flex justify="space-between" align="center" height={44} paddingX={16}>
            <Layout flex direction="row" gap={8} align="center">
              <Layout color="blue-500" borderRadius="circular" width={16} height={16} align="center" justify="center">
                <Icon name="checkmark" size={8} color="white" stroke={2} />
              </Layout>
              <Text size="body-sm">{action === 'create' ? 'Request created' : 'Request updated'}</Text>
            </Layout>
            <Layout flex direction="row" gap={8} align="center">
              <Text size="body-sm" color="gray-400">
                View
              </Text>
              <Icon name="externalLink" size={16} color="gray-400" />
            </Layout>
          </Layout>
        )}
        <Layout borderTop={!isMobile} paddingX={16} paddingY={12}>
          <Layout flex direction="column">
            <Layout>
              <Text align="left" size="body-md" maxLines={1}>
                {title}
              </Text>
              <Layout marginTop={9} width="100%">
                <Text size="body-xs" color="gray-400" maxLines={1} align="left">
                  {description}
                </Text>
              </Layout>
              <Layout marginTop={14} flex direction="row" justify="space-between">
                <Text size="body-xs" color="gray-400">
                  #{id}
                </Text>
                <StatusPill {...getSupportTicketStatusPillProps(status)} size="md" />
              </Layout>
            </Layout>
          </Layout>
        </Layout>
      </Layout>
    </Link>
  );
};

export default AIAssistantViewSupportTicket;
